<template>
<Dialog v-model:visible="visible" maximizable modal header="라이선스 정보 작성" :style="{ width: modalWidth }" @update:visible="handleDialogClose">
	  <div class="flex flex-wrap justify-content-left gap-2 mb-2">
      	<Divider align="left" type="solid">
	    	<b>고객사</b>
		</Divider>
		<p>
		    <AutoComplete v-model="company" optionLabel="companyName" dropdown :suggestions="filteredCompanys" @complete="companySearch" @change="setProjectList" style="width: 100%;"/>
		</p>
		
		<Divider align="left" type="solid">
	    	<b>프로젝트</b>
		</Divider>
		<p>
		    <AutoComplete v-model="project" optionLabel="projectName" dropdown :suggestions="filteredProjects" @complete="projectSearch" @change="setProjectInfo"  style="width: 100%;"/>
		</p>
		
		<!-- <Divider align="left" type="solid">
	    	<b>도입년도</b>
		</Divider>
		<p>
		    <input type="text" class="form-control" v-model="year" disabled />
		</p> -->

		<Divider align="left" type="solid">
				<b>도입제품</b>
		</Divider>
		<p v-if="licenseType === 'DESIGNER6'">
			<span class="p-tag p-tag-info" style="font-size: 1rem; padding: 4px 8px;">디자이너 6.0</span>
		</p>
		<p v-else-if="licenseType === 'REPORT6'" style="display: flex; gap: 16px; align-items: center;">
			<span style="font-weight: bold; margin-right: 4px;">제품</span>
			<span>
				<input type="radio" v-model="report6ProdType" value="REPORT_ONLY" id="prodReportOnly" @change="syncReport6Prod" />
				<label for="prodReportOnly" style="margin-left: 4px;">리포트</label>
			</span>
			<span>
				<input type="radio" v-model="report6ProdType" value="EFORM_ONLY" id="prodEformOnly" @change="syncReport6Prod" />
				<label for="prodEformOnly" style="margin-left: 4px;">이폼</label>
			</span>
			<span>
				<input type="radio" v-model="report6ProdType" value="REPORT_EFORM" id="prodReportEform" @change="syncReport6Prod" />
				<label for="prodReportEform" style="margin-left: 4px;">리포트 + 이폼</label>
			</span>
		</p>
		<p v-else>
			<MultiSelect v-model="issuedProd" display="chip" :style="{ 'max-width': '100%'} " :options="issuedProds" optionLabel="label" placeholder="제품 선택" filter  :maxSelectedLabels="5" @change="issuedProdSearch" class="w-full md:w-20rem" />
		</p>
		<p v-if="licenseType === 'REPORT6'" style="display: flex; gap: 16px; align-items: center;">
			<span style="font-weight: bold; margin-right: 4px;">상세 기능</span>
			<span>
				<input type="checkbox" v-model="report6Features" value="CLIP00015" id="featRepository" />
				<label for="featRepository" style="margin-left: 4px;">저장소</label>
			</span>
			<span>
				<input type="checkbox" v-model="report6Features" value="CLIP00016" id="featMirroring" />
				<label for="featMirroring" style="margin-left: 4px;">미러링</label>
			</span>
			<span>
				<input type="checkbox" v-model="report6Features" value="CLIP00017" id="featChat" />
				<label for="featChat" style="margin-left: 4px;">챗봇</label>
			</span>
		</p>
		
		<div v-if="partnerYn==='Y'">
			<Divider align="left" type="solid">
		    	<b>번들사</b>
			</Divider>
			<p>
			    <input type="text" class="form-control" v-model="partnerName" disabled />
			</p>
		</div>
		
		<Divider align="left" type="solid">
	    	<b>영업대표</b>
		</Divider>
		<p>
		    <input type="text" class="form-control" v-model="salesRepresentativeName" disabled />
		</p>
<!-- 		
		<Divider align="left" type="solid">
	    	<b>발급정보</b>
		</Divider>
		<p>
		    <input type="radio" v-model="issueReqInfoYn" value="Y" id="issueReqInfoYnY"/>
	        <label for="issueReqInfoYnY" style="margin-right: 8px;">있음</label>
	        <input type="radio" v-model="issueReqInfoYn" value="N" id="issueReqInfoYnN" @click="this.issueReqInfo = ''"/>
	        <label for="issueReqInfoYnN">없음</label>
		</p>
		 -->
		<div v-if="this.issueReqInfoYn === 'Y'">
			<div v-if="this.isMirrorink === false && licenseType !== 'DESIGNER6'">
				<!-- REPORT6: 클라우드 여부를 호스트 식별자 앞에 표시 -->
				<template v-if="licenseType === 'REPORT6'">
				<Divider align="left" type="solid">
					<b>클라우드</b>
				</Divider>
				<p>
					<Checkbox v-model="cloudYn" value="Y" />
				</p>
				</template>

				<Divider align="left" type="solid">
					<b>{{ licenseType === 'REPORT6' ? '호스트 식별자 (hostIdentifier)' : 'HostName' }}</b>
				</Divider>
				<p>
					<input v-model="hostName" class="form-control" @input="blockKorean"
						:placeholder="licenseType === 'REPORT6' ? '호스트 바인딩 (예: i-0a1b2c3d4e:ap-northeast-2 또는 pod@namespace). 클라우드 선택 시 필수' : '호스트명을 입력해 주세요. (복수인 경우 hostname1,hostname2...)'" />
				</p>

				<Divider align="left" type="solid">
					<b>CPU</b>
				</Divider>
				<p>
					<InputNumber :min="0" v-model="cpuInfo" />
				</p>
				
				<Divider align="left" type="solid">
					<b>IP 타입</b>
				</Divider>
				<p>
					<span v-for="(ip) in ipTypes" :key="ip" style="margin-right: 8px;">
						<input type="radio" v-model="ipType" :value="ip.code" :id="ip.code" @change="unsetIpData"/>
						<label :for="ip.code">{{ip.label}}</label>
					</span>
				</p>
				
				<Divider align="left" type="solid" v-if="ipType !== 'ALL'">
					<b>IP</b> 
				</Divider>
				<template v-if="ipType === 'MULTI'">
					<p v-for="row in ipRows" :key="row" style="display: flex; align-items: center; flex-wrap: nowrap;">
						<InputNumber v-model="row.ipAClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem" />.
						<InputNumber v-model="row.ipBClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem" />.
						<InputNumber v-model="row.ipCClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem" />.
						<InputNumber v-model="row.ipDClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem; margin-right: 8px;"/>
						<Button label="삭제" icon="pi pi-minus" outlined @click="removeRow(row)" />
					</p>				
					<p><Button label="IP추가" icon="pi pi-plus" severity="secondary" rounded @click="addRow(0)" />					
					<Button label="IP복붙" icon="pi pi-copy" severity="info" rounded @click="copyAndPaste" v-tooltip.top="{
							value: '복사 예시) (+개행) \n\n192.168.0.100\n192.168.0.200\n192.168.0.300'
						}" style="margin-left:5px"/></p>
				</template>
				<template v-if="ipType === 'BANDWIDTH'">
					<p v-for="row in ipRows" :key="row">
						<InputNumber v-model="row.ipAClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem" />.
						<InputNumber v-model="row.ipBClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem" />.
						<InputText maxlength="3" v-model="row.ipCClass" style="width: 56px" @keyup="checkIP(row.ipCClass)"/>.
						<InputText type="text" v-model="row.ipDClass" value="*" disabled style="width: 56px; margin-right: 8px;"/>
						<Button label="삭제" icon="pi pi-minus" outlined @click="removeRow(row)" />
					</p>
					<p><Button label="IP추가" icon="pi pi-plus" severity="secondary" rounded @click="addRow('*')" /></p>
				</template>
			</div>
			<!--
				<div v-if="this.isMirrorink">
					<Divider align="left" type="solid">
						<b>UUID</b>
					</Divider>
					<p>			    
						<input ref="uuidInput" v-model="uuid" class="form-control" @blur="checkUUID" placeholder="UUID 를 입력 해주세요. -(하이픈) 포함" />
					</p>
				</div>
			-->
			<template v-if="licenseType !== 'DESIGNER6'">
			<Divider align="left" type="solid">
		    	<b>서버타입</b>
			</Divider>
			<p>
			    <Dropdown v-model="serverType" editable :options="serverTypes" optionLabel="label" placeholder="서버타입을 선택해 주세요." class="w-full md:w-14rem" />
			</p>
			</template>

			<template v-if="licenseType !== 'REPORT6' && licenseType !== 'DESIGNER6'">
			<Divider align="left" type="solid">
		    	<b>클라우드</b>
			</Divider>
			<p>
			    <Checkbox v-model="cloudYn" value="Y" />
			</p>
			</template>

			<template v-if="licenseType !== 'DESIGNER6'">
			<Divider align="left" type="solid">
		    	<b>기간</b>
			</Divider>
			<p>
			    <span v-for="(period) in periodTypes" :key="period" style="margin-right: 8px;">
					<input type="radio" v-model="periodType" :value="period.code" :id="period.code"  @change="periodTypeCheck"/>
			        <label :for="period.code">{{period.label}}</label>
				</span>
			</p>
			<div v-if="this.periodType === 'TIME_LIMIT'">
				<p>
					<SelectButton v-model="period369Val" :options="period369Arr" aria-labelledby="basic" @change="changeEndDate369"/>
				</p>
				<Divider align="left" type="solid">
		    		<b>효력일</b>
				</Divider>
				<p>
					<Calendar v-model="startDate" dateFormat="yy/mm/dd" showIcon showButtonBar :showOnFocus="false" />
				</p>
				<Divider align="left" type="solid">
		    		<b>만료일</b>
				</Divider>
				<p>
					<Calendar v-model="endDate" dateFormat="yy/mm/dd" showIcon showButtonBar :showOnFocus="false" />
				</p>
			</div>
			</template>

			<template v-if="licenseType === 'DESIGNER6'">
			<Divider align="left" type="solid">
				<b>Preset</b>
			</Divider>
			<p>
				<span style="margin-right: 16px;">
					<input type="radio" v-model="designerPreset" :value="1" id="preset1" />
					<label for="preset1" style="margin-left: 4px;">Standard (Report)</label>
				</span>
				<span>
					<input type="radio" v-model="designerPreset" :value="2" id="preset2" />
					<label for="preset2" style="margin-left: 4px;">Professional (Report+EForm)</label>
				</span>
			</p>
			<Divider align="left" type="solid">
				<b>고객사명 (customerId)</b>
			</Divider>
			<p>
				<InputText :value="company ? company.companyName : ''" disabled style="width: 100%;" />
			</p>
			<Divider align="left" type="solid">
				<b>기간</b>
			</Divider>
			<p>
				<span style="margin-right: 8px;">
					<input type="radio" v-model="designerPeriodType" value="TIME_LIMIT" id="d6PeriodTime" @change="designerPeriodTypeChange"/>
					<label for="d6PeriodTime">기간제</label>
				</span>
				<span>
					<input type="radio" v-model="designerPeriodType" value="INDEFINITELY" id="d6PeriodIndef" @change="designerPeriodTypeChange"/>
					<label for="d6PeriodIndef">무기한</label>
				</span>
			</p>
			<div v-if="designerPeriodType === 'TIME_LIMIT'">
				<p>
					<SelectButton v-model="designerPeriod369Val" :options="period369Arr" aria-labelledby="basic" @change="changeDesignerEndDate369"/>
				</p>
				<Divider align="left" type="solid">
					<b>만료일</b>
				</Divider>
				<p>
					<Calendar v-model="designerExpiryDate" dateFormat="yy/mm/dd" showIcon showButtonBar :showOnFocus="false" :minDate="new Date()" />
				</p>
			</div>
			</template>

		</div>

		<div v-if="this.issueReqInfoYn === 'Y' && this.issuedLicense != ''">
			<template v-if="licenseType !== 'DESIGNER6'">
			<Divider align="left" type="solid">
				<b>UUID</b>
			</Divider>
			<p>
				<input ref="uuidInput" v-model="uuid" class="form-control" disabled />
			</p>
			<Divider align="left" type="solid">
				<b>신/구</b>
			</Divider>
			<p>
				<span v-for="(version,index) in licenseVersions" :key="version" style="margin-right: 8px; ">
					<input type="radio" v-model="licenseVersion" :value="version.code" :id="version.code" :style="{ 'display': index === 0 ? 'inline-block' : 'none' }" />
					<label :for="version.code" :style="{ 'display': index === 0 ? 'inline-block' : 'none' }">{{version.label}}</label>
				</span>
			</p>
			</template>
			<Divider align="left" type="solid">
					<b v-if="this.isMirrorink">InitLicenseData.hcinsdata</b>
					<b v-else-if="licenseType === 'REPORT6'">JSON (복호화 시 전체 내용 사용)</b>
					<b v-else-if="licenseType === 'DESIGNER6'">시리얼 키</b>
					<b v-else>key</b>
			</Divider>
			<p>
				<Textarea id = "keyTextArea" :value="displayIssuedLicense" autoResize :rows="licenseType === 'REPORT6' ? 10 : 4" disabled :style="{ 'font-family': 'Consolas,monaco,monospace' ,'min-width': '100%', 'font-size': licenseType === 'REPORT6' ? '11px' : 'inherit' }"/>
			</p>
			<p v-if="licenseType === 'REPORT6'">
				<Button label="한줄로 전체 복사" icon="pi pi-copy" severity="secondary" size="small" @click="copyOneLiner" />
			</p>
			<div v-if="this.isMirrorink">
				<Divider align="left" type="solid">						
						<b>License.hcinsKey</b>
				</Divider>
				<p>
					<Textarea id = "keyTextArea" v-model="issuedLicense2" autoResize rows="4" disabled :style="{ 'font-family': 'Consolas,monaco,monospace' ,'min-width': '100%'  }"/>
				</p>	
			</div>	
		</div>
      </div>
	<template #footer>
	<Button label="닫기" id="licenseIssueCloseButton" icon="pi pi-times" @click="$emit('closesModal'); visible = false;" text />
	<!-- <Button label="저장" id="licenseSaveButton" icon="pi pi-check" @click="regist();" autofocus />		 -->	
	<Button label="발급" id="licenseIssueRegistButton" icon="pi pi-check" autofocus v-if="isIssuer == true && this.issueReqInfoYn === 'Y' && this.isUpdateConfirmModalOpenBefore == true" @click="handleRegistButtonClick()"  />						
	<Button label="발급" id="licenseIssueRegistButton2" icon="pi pi-check" autofocus data-bs-toggle="modal" v-if="isIssuer == true && this.issueReqInfoYn === 'Y' && this.isUpdateConfirmModalOpen == true" data-bs-target="#updateConfirmMoral"/>						
	</template>	
	<div class="modal fade" id="updateConfirmMoral" tabindex="-1" aria-labelledby="updateConfirmMoralLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="mb-3">
                    <label for="message-text" class="col-form-label">발급 내용</label>
                    <textarea class="form-control" 
                              v-model="licenseComment" 
                              id="message-text" 
                              placeholder="라이선스 발급관련정보를 입력해 주세요."></textarea>
                </div>
            </div>
            <div class="modal-footer" v-if="processing == false">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="licenseIssuedCloseButton">닫기</button>
                <button type="button" class="btn btn-primary" @click="licenseType === 'DESIGNER6' ? updateDesigner() : issue();" :data-bs-dismiss="modal">발급</button>
            </div>
            <div class="modal-footer" v-if="processing == true">
                <button class="btn btn-primary" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Please Wait...
                </button>
            </div>
        </div>
    </div>
</div>

  </Dialog>
</template>

<script>
import _ from "lodash";
export default {
  name: 'LicenseInfoRegistModal',
  data(){
    return{
      companys: [],
      filteredCompanys: [],      
      issuedProds: [],
      projects: [],
      filteredProjects: [],
      requestDeptEmails: [],
      filteredRequestDeptEmails: [],
      ipTypes: [],
      serverType: "",
      serverTypes: {},
      periodTypes: {},
      licenseVersions: {},
      company: "",
      project: "",	
	  projectSerialNo: "",
      year: "",
	  issuedProd: "",
      deliveryProdName: "",
      partnerName: "",
      issueReqInfoYn: 'Y',
      issueReqInfo: "",
      cpuInfo: "",
      ipType: "MULTI",
      ipRows: [
	      {ipAClass: 0, ipBClass: 0, ipCClass: 0, ipDClass: 0}
	    ],
      cloudYn: "",
      startDate: new Date(),
      endDate: new Date(),
      periodType: "TIME_LIMIT",
      licenseVersion: "V3",
      requestDeptEmail: "",
      visible: true,
      modalWidth: this.$isMobile() ? '100vw' : '35vw',
      partnerYn: "",
      licenseSerialNo: "0000",
      requestInfo: "",
	  processing: false,
	  issuedLicense: "",
	  issuedLicense2: "",
	  period369Arr:['3개월','6개월','12개월'],	
	  period369Val:'',
	  isSameIPs: false,
	  isUpdateConfirmModalOpenBefore: true,
	  isUpdateConfirmModalOpen: false,
	  hostName: "",
	  isMirrorink: false,
	  uuid: "",
	  licenseComment: "",
	  wasIssued: false,
	  licenseTypeVisible: false,
	  report6ProdType: 'REPORT_ONLY',
	  // [상세기능] 저장소/미러링/챗봇. 제품과 독립적으로 복수 선택 가능
	  report6Features: [],
	  designerPreset: 2,
	  designerExpiryYmdStr: "",
	  designerExpiryDate: null,
	  designerPeriodType: 'TIME_LIMIT',
	  designerPeriod369Val: '',
	  designerLicenseComment: "",
	  selectedLicenseType: "",
	  designerCustomerId: 1,
		  designerProduct: 1,
	  designerNonce: 0,
    }
  },
  props: {
	isIssuer: Boolean,
	licenseType: { type: String, default: 'LEGACY' },
  },
  components: {
  },
  created(){
    var param = {
    };
    
    this.$get('/biz/company/list',  {
	            	params: param
	       		 },
                function(response, i){
                   	i.companys = response.data.result;   //기존데이터에 추가
                },
                function(e, i){
                	console.log(e);
                }
     );
    
    this.$code(["REQUEST_DEPT_CODE", "IP_TYPE", "SERVER_TYPE", "PERIOD_TYPE", "LICENSE_VERSION"], false,
		function(result, i){
           i.requestDeptEmails = result.requestDeptCode;
           i.ipTypes = result.ipType;
           i.serverTypes = result.serverType;
           i.periodTypes = result.periodType;
           i.licenseVersions = result.licenseVersion;
        },
        function(e, i){
        	console.log(e);
        }
	);

	this.$code(["PROD_CODE"], false,
		function(result, i){
			i.issuedProds = result.prodCode.filter(item => (item.codeSort < 10 && item.codeSort >= 1) || item.codeSort >= 1000 );
			var newProdCodes = ['CLIP00007', 'CLIP00008', 'CLIP00009', 'CLIP00010', 'CLIP00015', 'CLIP00016', 'CLIP00017'];
			if (i.licenseType === 'LEGACY') {
				i.issuedProds = i.issuedProds.filter(function(p) { return newProdCodes.indexOf(p.value) === -1; });
				if (Array.isArray(i.issuedProd)) {
					i.issuedProd = i.issuedProd.filter(function(p) { return newProdCodes.indexOf(p.value) === -1; });
				}
			} else if (i.licenseType === 'REPORT6') {
				i.licenseVersion = 'REPORT6';
				var report6Codes = ['CLIP00007', 'CLIP00008'];
				i.issuedProds = i.issuedProds.filter(function(p) { return report6Codes.indexOf(p.value) !== -1; });
				i.report6ProdType = 'REPORT_ONLY';
				i.report6Features = [];
				i.syncReport6Prod();
			} else if (i.licenseType === 'DESIGNER6') {
				var designer6Codes = ['CLIP00009', 'CLIP00010'];
				i.issuedProds = i.issuedProds.filter(function(p) { return designer6Codes.indexOf(p.value) !== -1; });
				i.issuedProd = i.issuedProds.filter(function(p) { return p.value === 'CLIP00009'; });
			}
		},
		function(e, i){
			console.log(e);
		}
	);
  }, watch: {
	isMirrorink(){}
  },
  computed: {
    displayIssuedLicense() {
      if (this.licenseType === 'REPORT6' && this.issuedLicense) {
        try {
          var parsed = JSON.parse(this.issuedLicense);
          return JSON.stringify(parsed, null, 2);
        } catch(e) {
          return this.issuedLicense;
        }
      }
      return this.issuedLicense;
    }
  },
  mounted() {
		//달력(속성 변경)
		this.$calendar();
  },
  methods: {
  	periodTypeCheck(){
  		if(this.periodType != "TIME_LIMIT"){
  			this.startDate = "";
      		this.endDate = "";
  		}else{
  			this.startDate = new Date();
  		}
  	},
	changeEndDate369(){
		if(this.period369Val != null) {
			var N_MonthsLater = new Date(this.startDate);			
			N_MonthsLater.setMonth(N_MonthsLater.getMonth() + Number(this.period369Val.split('개월')[0]));
			this.endDate = new Date(N_MonthsLater);
		}
	},
  	unsetData(){
  		this.cpuInfo = "";
      	this.ipType = "MULTI";
      	this.ipRows = [{ipAClass: 0, ipBClass: 0, ipCClass: 0, ipDClass: 0}];
      	this.serverType = "";
      	this.cloudYn[0] = "N";		          
      	this.periodType = "INDEFINITELY";
      	this.startDate = "";
      	this.endDate = "";
  	},
	//저장 버튼 - 사용 안함
    // regist() {
    // 	var checked = false;
    // 	var ipAddresses = [];
    	
    // 	if(this.issueReqInfoYn == 'N'){

	// 		this.cpuInfo = "";
	//       	this.ipType = "MULTI";
	//       	this.ipRows = [];
	//       	this.serverType = "";
	//       	this.cloudYn = "N";		          
	//       	this.periodType = "INDEFINITELY";
	//       	this.startDate = "";
	//       	this.endDate = "";			
    // 	}else{	        
	//         if(this.ipType != 'ALL'){
	// 			this.ipRows.forEach(function(ip, index) {
				
	// 				if(ip.ipAClass == null || ip.ipAClass == ""){
	// 				ip.ipAClass = 0;
	// 				}
					
	// 				if(ip.ipBClass == null || ip.ipBClass == ""){
	// 				ip.ipBClass = 0;
	// 				}
					
	// 				if(ip.ipCClass == null || ip.ipCClass == ""){
	// 				ip.ipCClass = 0;
	// 				}
					
	// 				if(ip.ipDClass == null || ip.ipDClass == ""){
	// 				ip.ipDClass = 0;
	// 				}
				
	// 				ipAddresses.push(ip.ipAClass + '.' + ip.ipBClass + '.' + ip.ipCClass + '.' + ip.ipDClass);
	// 			});
	//         }	        
    // 	}

	// 	if(this.company == ""){
    // 		this.$messageShow('고객사 정보는 필수입력항목입니다.', 'warn');
	// 	    return checked;
    // 	}
    	
    // 	if(this.project == ""){
    // 		this.$messageShow('프로젝트 정보는 필수입력항목입니다.', 'warn');
	// 	    return checked;
    // 	} else {
	// 		checked = true;
	// 	}
    	
    // 	if(checked){
    // 		if(confirm("저장 하시겠습니까?")){
    // 			var param = {
	// 	          "companySeq": this.company.companySeq,
	// 	          "projectUid": this.project.projectUid,
	// 	          "issueReqInfoYn" : this.issueReqInfoYn,
	// 	          "cpuInfo": this.cpuInfo,
	// 	          "ipType": this.ipType,
	// 	          "ipFrom" : ipAddresses,
	// 	          "serverType": this.serverType.value,
	// 	          "cloudYn": this.cloudYn[0],		          
	// 	          "periodType": this.periodType,
	// 	          "startDate" : this.periodType == "TIME_LIMIT" ? this.$simpleDateTimeFormat(this.startDate, "yyyy/MM/dd") : "",
	// 	          "endDate" : this.periodType == "TIME_LIMIT" ? this.$simpleDateTimeFormat(this.endDate, "yyyy/MM/dd") : "",
	// 	          "issueReqInfo" : this.issueReqInfo,
	// 	          "requestDeptEmail": this.requestDeptEmail.value,
	// 	          "registerEmail" : this.$store.getters.getUserEmail,
	// 	          "issueStatusType" : "SAVED",
	// 	          "licenseSerialNo" : this.licenseSerialNo,
	// 	          "requestInfo" : this.requestInfo,
	// 	        };
	// 	        console.log(this.licenseSerialNo);
	// 	        this.$post('/biz/license/add', param,
	// 		                function(response, i){
	// 		                	i.$messageShow('저장이 완료되었습니다.', 'success');
	// 		                	i.$emit('update');
	// 		                 	i.visible = false;
	// 		                	i.$emit('closesModal');
	// 		                },
	// 		                function(e, i){
	// 		                	i.$messageShow(e, 'danger');
	// 		                }
	// 		 	);  
    // 		}
    	
    // 	}
    
    // },
    setProjectList() {
    	
    	this.partnerName = "";
		this.deliveryProdName = "";
		this.salesRepresentativeName = "";
    	this.project = "";
    	if(this.company.companySeq != undefined){
			var param = {
				companySeq : this.company.companySeq,
			};
	    
			this.$get('/biz/project/list',  {
			            	params: param
				 },
			        function(response, i){
			    		i.projects = response.data.result;   //기존데이터에 추가
			        },
			        function(e, i){
			        	console.log(e);
			        }
			);
		}
            
    },
    companySearch(event) {
             setTimeout(() => {
                if (!event.query.trim().length) {
					this.filteredCompanys = this.companys.filter((company) => company.useYn === 'Y');
                } else {
                    this.filteredCompanys = this.companys.filter((company) => {
						return company.useYn === 'Y' && company.companyName.toLowerCase().includes(event.query.toLowerCase());
                    });
                }
            }, 250);
            
            
    },
    projectSearch(event) {
             setTimeout(() => {
                if (!event.query.trim().length) {
					this.filteredProjects = this.projects.filter((project) => project.useYn === 'Y');
                } else {
                    this.filteredProjects = this.projects.filter((project) => {
						return project.useYn === 'Y' &&  project.projectName.toLowerCase().includes(event.query.toLowerCase());
                    });
                }
            }, 250);
            
    },
    requestDeptEmailSearch(event){
    		setTimeout(() => {
                if (!event.query.trim().length) {
                    this.filteredRequestDeptEmails = [...this.requestDeptEmails];
                } else {
                    this.filteredRequestDeptEmails = this.requestDeptEmails.filter((requestDeptEmail) => {
                        return requestDeptEmail.label.toLowerCase().includes(event.query.toLowerCase());
                    });
                }
            }, 250);
    },
    setProjectInfo(){
    	const current = new Date();
    	
    	if(this.project.companySeq != undefined && this.project.projectUid != undefined ){
	    	var param = {
		    	companySeq : this.project.companySeq,
		    	projectUid : this.project.projectUid
		    };
		  
		  	this.$get(`/biz/project/get`, {
			            	params: param
			       		 },
			                function(response, i){
								var detail = response.data.detail;
						    	i.partnerName = detail.partnerName;
						    	i.deliveryProdName = detail.deliveryProdName;
						    	i.salesRepresentativeName = detail.salesRepresentativeName;
						    	i.partnerYn = detail.partnerYn;
								i.projectSerialNo = detail.projectSerialNo;
						    	i.year = detail.year !== "" ? detail.year : current.getFullYear();

								var deliveryProds = [];
										 
								i.issuedProds.forEach(function(deliveryProd, index) {
									detail.deliveryProdCode.split(",").forEach(function(issuedProds, index) {
										if(issuedProds === deliveryProd.value){
											deliveryProds.push(deliveryProd);
										}
									});
									
								});								
								i.issuedProd = deliveryProds;
								i.isMirrorink = deliveryProds.length > 0 && deliveryProds[0].code == "CLIP03001" ? true : false;
								if (i.licenseType === 'REPORT6') { i.syncReport6Prod(); }
			                },
			                function(e, i){
			                	console.log(e);
			                }
			 );

			 
		 }
    
    },    
    addRow: function(ipDClass){
      this.ipRows.push({ipAClass: 0, ipBClass: 0, ipCClass: 0, ipDClass: ipDClass});
    },
    removeRow: function(row){
      this.ipRows.splice(this.ipRows.indexOf(row), 1);
    },
    checkIP: function(ipCClass){
    	var regExp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])|\*)$/i;
	    if(!regExp.test(ipCClass)){
	    	this.$messageShow("IP 주소는 클래스별 0부터 255사이의 숫자 또는 '*'문자를 이용하여 입력을 해야 합니다.", 'warn');
			return false;
	    }
    },
	checkIP2: function(ipCClass){
		var regExp = /^(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i;			
		if(!regExp.test(ipCClass)){
			this.$messageShow("IP 주소는 클래스별 0부터 255사이의 숫자를 이용하여 입력을 해야 합니다.", 'warn');
			return false;
		}
	},
    unsetIpData: function(){
    	if(this.ipType == 'ALL'){
    		this.ipRows = [];
    	}else{
    		if(this.ipType == 'MULTI'){
    			this.ipRows = [{ipAClass: 0, ipBClass: 0, ipCClass: 0, ipDClass: 0}];
	    	}else{
	    		this.ipRows = [{ipAClass: 0, ipBClass: 0, ipCClass: 0, ipDClass: '*'}];
	    	}
    	}
    },
	issue() {
		var checked = false;
		var ipAddresses = [];
		var issuedProdCodes = [];

		if (this.licenseType === 'REPORT6') {
			issuedProdCodes = this.report6ProdCodes();
		} else if(this.issuedProd != null && this.issuedProd != 'undefined' && this.issuedProd != ''){

					this.issuedProd = _.uniqBy(this.issuedProd, 'value');

				this.issuedProd.forEach(function(prod, index) {
					issuedProdCodes.push(prod.value);
				});

				if(issuedProdCodes.length < 1){
						this.$messageShow('도입제품은 한개이상 필수선택항목입니다.', 'warn');
						return checked;
					}

				}else{
					this.$messageShow('도입제품은 한개이상 필수선택항목입니다.', 'warn');
					return checked;
				}
		
		if((this.cpuInfo == null || this.cpuInfo == "" || this.cpuInfo == 0) && this.isMirrorink == false && this.licenseType !== 'REPORT6') {
			this.$messageShow('CPU 정보는 필수입력항목입니다.', 'warn');
			return checked;
		}
		
		if (this.licenseType === 'REPORT6' && this.cloudYn && this.cloudYn[0] === 'Y' && (!this.hostName || this.hostName.trim() === '')) {
			this.$messageShow('클라우드 선택 시 호스트 식별자(hostIdentifier) 입력이 필요합니다.', 'warn');
			return checked;
		}

		if(this.ipType != 'ALL'){

			if(this.ipRows.length < 1){
				if(this.licenseType !== 'REPORT6'){
					this.$messageShow('IP 정보는 한개 이상 입력이 필요합니다.', 'warn');
					return checked;
				}
			}else{
				this.ipRows.forEach(function(ip, index) {

					if(ip.ipAClass == null || ip.ipAClass == ""){
						ip.ipAClass = 0;
					}
					if(ip.ipBClass == null || ip.ipBClass == ""){
						ip.ipBClass = 0;
					}
					if(ip.ipCClass == null || ip.ipCClass == ""){
						ip.ipCClass = 0;
					}
					if(ip.ipDClass == null || ip.ipDClass == ""){
						ip.ipDClass = 0;
					}
					ipAddresses.push(ip.ipAClass + '.' + ip.ipBClass + '.' + ip.ipCClass + '.' + ip.ipDClass);
				});
			}

		}
		
		if(this.serverType == "" && this.licenseType !== 'DESIGNER6') {
			this.$messageShow('서버타입은 필수입력항목입니다.', 'warn');
			return checked;
		}
		
		if(this.periodType == "TIME_LIMIT"){
			if(this.startDate == "" || this.endDate == "" || this.startDate == null || this.endDate == null){
					this.$messageShow('효력일, 만료일 입력이 필요합니다.', 'warn');
				return checked;
			}else{
					if(this.startDate > this.endDate){
						this.$messageShow('만료일이 효력일보다 빠른날짜 입니다. 기간 확인이 필요합니다.', 'warn');
						return checked;
					}
			}
		}
				
		if(this.licenseComment == ""){
			this.$messageShow('발급 내용 입력이 필요합니다.', 'warn');
			return checked;
		}else{
			checked = true;	
		}
		if(checked){			
			if(confirm("라이선스 발급을 진행하시겠습니까?")){
				this.processing = true;
				var param = {					
					"companySeq": this.company.companySeq ,
					"companyName": this.company.companyName ,
					"projectUid": this.project.projectUid ,
					"projectName": this.project.projectName ,
					"issueReqInfoYn" : 'Y',
					"cpuInfo": this.cpuInfo,
					"ipType": this.ipType,
					"ipFrom" : ipAddresses,
					"serverType": this.serverType.value,
					"cloudYn": this.cloudYn != null ? this.cloudYn[0] : "",		          
					"periodType": this.periodType,
					"startDate" : this.periodType == "TIME_LIMIT" ? this.$simpleDateTimeFormat(this.startDate, "yyyy/MM/dd") : "",
					"endDate" : this.periodType == "TIME_LIMIT" ? this.$simpleDateTimeFormat(this.endDate, "yyyy/MM/dd") : "",
					"registerEmail" : this.$store.getters.getUserEmail,
					"modifierEmail" : this.$store.getters.getUserEmail,
					"issueStatusType" : "ISSUED",
					"etc" : this.etc,
					"licenseComment" : this.licenseComment,
					"licenseVersion" : this.licenseVersion,
					"issuedProdCodes" : issuedProdCodes,
					"licenseSerialNo" : this.projectSerialNo,
					"hostName" : this.hostName,
				};
				this.$post('/biz/license/issue', param,
								function(response, i){
									i.processing = false;
									 var detail = response.data.detail;
									i.issuedLicense = detail.issuedLicense;
									if(i.isMirrorink) {
										i.issuedLicense2 = detail.issuedLicense2;
										i.uuid = detail.uuid;
									}
									i.wasIssued = true;
									i.$messageShow('라이선스 발급이 완료되었습니다.', 'success');
									
									setTimeout(() => {
										document.getElementById("licenseIssuedCloseButton").click();	
										document.getElementById("keyTextArea").scrollIntoView({ behavior: "smooth" });		
										document.getElementById("licenseIssueRegistButton").style.display = "none";	
										//document.getElementById("licenseSaveButton").style.display = "none";								
									}, 100);
								},
								function(e, i){
									i.processing = false;
									i.errorMessage = e;
								}
					 );  
			}		
		}
	
	},
	copyAndPaste(){						
		if(navigator.clipboard == null){
				this.$messageShow("https 에서만 지원 합니다.", 'warn');
		} else {			
			var ipRows_prev = this.ipRows;
			this.ipRows = [];	
			
			setTimeout(() => {
					navigator.clipboard.readText().then(text => {
					const lines = text.split('\r\n');
					for (let i = 0; i < lines.length; i++) {
						const ipAddressParts = lines[i].split('.');

						var regExp = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i;
						if(!regExp.test(lines[i])) {
							this.$messageShow(i+1+ "번째 IP 주소가 잘 못 되었습니다.", 'warn');
							this.ipRows = ipRows_prev;
							break;
						} else {
							if (ipAddressParts.length === 4 && (this.checkIP2(ipAddressParts[0]) != false && this.checkIP2(ipAddressParts[1])) != false && this.checkIP2(ipAddressParts[2]) != false && this.checkIP2(ipAddressParts[3]) != false) {							
							this.addRow(i);
							const newRow = this.ipRows[i];
							newRow.ipAClass = parseInt(ipAddressParts[0]);
							newRow.ipBClass = parseInt(ipAddressParts[1]);
							newRow.ipCClass = parseInt(ipAddressParts[2]);
							newRow.ipDClass = parseInt(ipAddressParts[3]);
							} else {
								this.ipRows = ipRows_prev;
							}
						}						
					}
				}).catch(err => {
					console.error('Failed to read clipboard contents: ', err);
				});
			}, 300);
		}	
	},
	handleRegistButtonClick() {
		if (this.licenseType === 'DESIGNER6') {
			if (this.designerPeriodType === 'TIME_LIMIT') {
				if (!this.designerExpiryDate) {
					this.$messageShow('만료일을 선택해주세요.', 'warn'); return;
				}
				var today = new Date(); today.setHours(0,0,0,0);
				if (this.designerExpiryDate < today) {
					this.$messageShow('만료일은 오늘 이후 날짜를 선택해주세요.', 'warn'); return;
				}
			}
			this.isUpdateConfirmModalOpen = true;
			this.isUpdateConfirmModalOpenBefore = false;
			var self = this;
			this.$nextTick(function() {
				document.getElementById("licenseIssueRegistButton2").click();
				self.isUpdateConfirmModalOpen = false;
				self.isUpdateConfirmModalOpenBefore = true;
			});
		} else {
			this.openUpdateConfirmModal();
		}
	},
	designerPeriodTypeChange() {
		if (this.designerPeriodType === 'INDEFINITELY') {
			this.designerExpiryDate = null;
			this.designerPeriod369Val = '';
		} else {
			this.designerExpiryDate = null;
			this.designerPeriod369Val = '';
		}
	},
	changeDesignerEndDate369() {
		if (this.designerPeriod369Val) {
			var months = parseInt(this.designerPeriod369Val.split('개월')[0]);
			var d = new Date();
			d.setMonth(d.getMonth() + months);
			this.designerExpiryDate = d;
		}
	},
	openUpdateConfirmModal() {		
		var ipAddresses = [];
		this.ipRows.forEach(function(ip, index) {
			
			if(ip.ipAClass == null || ip.ipAClass == ""){
				ip.ipAClass = 0;
			}
			if(ip.ipBClass == null || ip.ipBClass == ""){
				ip.ipBClass = 0;
			}
			if(ip.ipCClass == null || ip.ipCClass == ""){
				ip.ipCClass = 0;
			}
			if(ip.ipDClass == null || ip.ipDClass == ""){
				ip.ipDClass = 0;
			}
			ipAddresses.push(ip.ipAClass + '.' + ip.ipBClass + '.' + ip.ipCClass + '.' + ip.ipDClass);
		});		
		var paramData = {
			"pageNum": 1,
			"pageSize": 1000000,
			"searchKeywordIP": ipAddresses,	
			"isAdmin": "N",		
			"isLicenseExpiringSoon": false,
		};     
		this.$get('/biz/license/list', {
				params: paramData
			},
			function(response, i){				
				var sameIPCnt = response.data.pagination.total;
				 
				 if (sameIPCnt != 0) {
					var sameIPList = response.data.pagination.list;
					var sameIPStr = "";
					sameIPList.forEach(item => {
						sameIPStr +="\n" + item.companyName + " / " + item.projectName;
					});					
					if (window.confirm('IP : ' + ipAddresses+ '\n동일한 IP로 발급한 내역이 '+sameIPCnt+'건 있습니다. 계속 진행하시겠습니까?\n'+sameIPStr)) {
						i.isUpdateConfirmModalOpen = true;
						i.isUpdateConfirmModalOpenBefore = false;
						i.$nextTick(() => {
							document.getElementById("licenseIssueRegistButton2").click();
							i.isUpdateConfirmModalOpen = false;
							i.isUpdateConfirmModalOpenBefore = true;
						});
					}
				} else {
					i.isUpdateConfirmModalOpen = true;
					i.isUpdateConfirmModalOpenBefore = false;
					i.$nextTick(() => {
						document.getElementById("licenseIssueRegistButton2").click();
						i.isUpdateConfirmModalOpen = false;
						i.isUpdateConfirmModalOpenBefore = true;
					});
				}
				
			},
			function(e, i){
				console.log(e);
			}
		);
	},	
	blockKorean(event) {	
		const original = event.target.value		
		const filtered = original
			.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, '') // 한글 제거
			.replace(/\s/g, '')               // 모든 공백(띄어쓰기 포함) 제거
			.trim()                           // 앞뒤 공백 제거 (보통 \s 제거로 충분하지만 안정성 ↑)
  		event.target.value = filtered
	},
	checkUUID(event) {
		const value = event.target.value;
		var ck = false;
		
		if (value.length !== 36) {			
			ck = true;
			this.$refs.uuidInput.focus();
		}
		
		const uuidPattern = /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*-)[A-Za-z0-9-]{36}$/;

		if (!uuidPattern.test(value)) {
			ck = true;
			this.$refs.uuidInput.focus();
		}
		
		if(ck) 
			this.$messageShow("UUID 키 값이 올바르지 않습니다.", 'warn');
	},
	copyOneLiner() {
		if (navigator.clipboard) {
			navigator.clipboard.writeText(this.issuedLicense).then(() => {
				this.$messageShow('한 줄 JSON이 클립보드에 복사되었습니다.', 'success');
			}).catch(() => {
				this.$messageShow('복사에 실패했습니다. https 환경인지 확인해주세요.', 'warn');
			});
		} else {
			this.$messageShow('https 에서만 지원합니다.', 'warn');
		}
	},
	// [REQ-F-001] REPORT6 도입제품 3분기 -> 제품코드 매핑 (단일 진실 공급원)
	//   REPORT_ONLY  (R6)  : CLIP00007
	//   EFORM_ONLY   (E6)  : CLIP00008
	//   REPORT_EFORM (RE6) : CLIP00007 + CLIP00008
	// [REQ] 제품은 택1 필수, 상세기능은 그 위에 복수 선택 가능.
	//   제품     REPORT_ONLY  (R6)  : CLIP00007
	//            EFORM_ONLY   (E6)  : CLIP00008
	//            REPORT_EFORM (RE6) : CLIP00007 + CLIP00008
	//   상세기능 CLIP00015(저장소) / CLIP00016(미러링) / CLIP00017(챗봇)
	// 제품 라디오는 기본값이 있어 항상 하나가 선택된 상태이므로 필수 조건이 자동 충족된다.
	report6ProdCodes() {
		var codes;
		switch (this.report6ProdType) {
			case 'EFORM_ONLY':   codes = ['CLIP00008']; break;
			case 'REPORT_EFORM': codes = ['CLIP00007', 'CLIP00008']; break;
			default:             codes = ['CLIP00007']; break;
		}
		return codes.concat(this.report6Features || []);
	},
	syncReport6Prod() {
		var codes = this.report6ProdCodes();
		this.issuedProd = this.issuedProds.filter(function(p) { return codes.indexOf(p.value) !== -1; });
	},
	issuedProdSearch(event) {				
		if(event.value.some(item => item.code.includes("CLIP03001"))) {
			if(event.value.length > 1) {
				this.$messageShow("MirrorLink는 단독으로만 사용 가능합니다.", 'warn');
				this.issuedProd = event.value.filter(item => item.code !== "CLIP03001");
				this.isMirrorink = false;
			} else {
				this.isMirrorink = true;
			}
		} else {
			this.isMirrorink = false;
		}
	},
	handleDialogClose() {
		if (this.wasIssued) { this.$emit('update'); }
		this.$emit('closesModal');
		this.visible = false;
	},
	updateDesigner() {
		if (!this.licenseComment || this.licenseComment.trim() === '') {
			this.$messageShow('발급 내용 입력이 필요합니다.', 'warn');
			return;
		}
		if (!this.company || !this.company.companySeq) {
			this.$messageShow('고객사를 선택해주세요.', 'warn'); return;
		}
		if (!this.project || !this.project.projectUid) {
			this.$messageShow('프로젝트를 선택해주세요.', 'warn'); return;
		}
		if (this.designerPeriodType === 'TIME_LIMIT') {
			if (!this.designerExpiryDate) {
				this.$messageShow('만료일을 선택해주세요.', 'warn'); return;
			}
			var today = new Date(); today.setHours(0,0,0,0);
			if (this.designerExpiryDate < today) {
				this.$messageShow('만료일은 오늘 이후 날짜를 선택해주세요.', 'warn'); return;
			}
		}
		this.processing = true;
		var expiryYmd;
		if (this.designerPeriodType === 'INDEFINITELY') {
			expiryYmd = 99991231;
		} else {
			var d = this.designerExpiryDate;
			expiryYmd = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
		}
		var param = {
			"companySeq": this.company.companySeq,
			"companyName": this.company.companyName,
			"projectUid": this.project.projectUid,
			"projectName": this.project.projectName,
			"issueReqInfoYn": 'Y',
			"registerEmail": this.$store.getters.getUserEmail,
			"modifierEmail": this.$store.getters.getUserEmail,
			"issueStatusType": "ISSUED",
			"licenseComment": this.licenseComment,
			"licenseVersion": "DESIGNER6",
			"issuedProdCodes": this.designerPreset === 2 ? ["CLIP00009"] : ["CLIP00010"],
			"licenseSerialNo": this.projectSerialNo,
			"preset": this.designerPreset,
			"aiFlags": 0,
			"designerCustomerId": this.company ? this.company.companySeq : 0,
			"designerExpiryYmd": expiryYmd,
			"designerProduct": this.designerProduct,
			"designerNonce": this.designerNonce,
		};
		this.$post('/biz/license/issue', param,
			function(response, i) {
				i.processing = false;
				i.issuedLicense = response.data.detail.issuedLicense;
				i.wasIssued = true;
				i.$messageShow('디자이너 라이선스 발급이 완료되었습니다.', 'success');
				setTimeout(function() {
					document.getElementById("licenseIssuedCloseButton").click();
					document.getElementById("keyTextArea").scrollIntoView({ behavior: "smooth" });
				}, 100);
			},
			function(e, i) { i.processing = false; i.errorMessage = e; }
		);
	},
  }
}
</script>

<style scoped>
.black-bg {
  width: 100%; 
  height: 100%;
  background: rgba(0,0,0,0.5);
  position: fixed;
  padding: 20px;
}
.white-bg {
  width: 400px;
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin: 0 auto;
  transform: translate(-50%, 5%);
}
h4 {
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgb(169, 168, 168);
}
.check {
  margin-left: 40px;
}

</style>
